var _text, _tspan, _text2, _tspan2, _path, _text3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisibilityWheel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: 226.819,
    viewBox: "0 0 259.603 226.819",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_3110",
    "data-name": "Group 3110",
    transform: "translate(-1901 -2722)"
  }, _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "_75_",
    "data-name": "75%",
    transform: "translate(2073 2860.416)",
    fill: "#74ad85",
    fontSize: 44,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -45.43,
    y: 0
  }, "75%"))), /*#__PURE__*/React.createElement("text", {
    id: "_28_",
    "data-name": "28%",
    transform: "translate(2073 2905.957)",
    fill: "#99c2ad",
    fontSize: 24,
    fontFamily: "Montserrat-Regular, Montserrat",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: -24.3,
    y: 0
  }, "28%"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "Current",
    transform: "translate(2073 2819.311)",
    fill: "#74ad85",
    fontSize: 14,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -23.358,
    y: 0
  }, "Current"))), /*#__PURE__*/React.createElement("text", {
    id: "Original",
    transform: "translate(2073 2880.957)",
    fill: "#99c2ad",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: -20.464,
    y: 0
  }, "Original"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M636.165,486.892c0,.365.028.725.028,1.09a73.708,73.708,0,1,1-73.708-73.708c1.094,0,2.181.036,3.265.082V399.626c-1.086-.04-2.171-.084-3.265-.084a88.439,88.439,0,1,0,88.438,88.44c0-.365-.024-.725-.028-1.09Z",
    transform: "translate(1509.68 2372.4)",
    fill: "#74ad85"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M29.871,989.485h0a107.207,107.207,0,0,1-7.522-21.94,108.743,108.743,0,0,1-.447-45.507,107.165,107.165,0,0,1,16.213-38.53,108.068,108.068,0,0,1,47.408-39.04,107.208,107.208,0,0,1,20.227-6.279A108.548,108.548,0,0,1,127.466,836c1.343,0,2.7.051,4,.1h.007l.14.005-.114,14.228c-1-.043-2.512-.1-4.036-.1a94.211,94.211,0,0,0-18.848,1.9A93.01,93.01,0,0,0,75.177,866.2a93.795,93.795,0,0,0-33.884,41.146,93.048,93.048,0,0,0-5.45,17.555,94.395,94.395,0,0,0,.322,39.207,93.02,93.02,0,0,0,6.349,18.806l-12.643,6.566Z",
    transform: "translate(1944.698 1916.628)",
    fill: "#99c2ad",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.495,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    id: "Expanded_Keyword_Visibility",
    "data-name": "Expanded Keyword Visibility",
    transform: "translate(1901 2737)",
    fill: "#7f7f7f",
    fontSize: 14,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Expanded Keyword Visibility")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityWheel);
export default __webpack_public_path__ + "static/media/visibilityWheel.ab5d77f4.svg";
export { ForwardRef as ReactComponent };